// extracted by mini-css-extract-plugin
module.exports = {"description":"Header-module--description--2A-tl"};